//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: "bar",
	props: {
		data: {
			type: Object,
		},
		desc: {
			type: Function,
			required: true,
		},
	},
	computed: {
		descString() {
			return this.desc(this.data);
		},
	},
};
